import { PhoneNumberDto } from '@/types/PhoneNumberDto.ts';

/**
 * Cyfry w trójkach, licząc od końca — „601234567” → „601 234 567”.
 *
 * Grupujemy od końca, bo numery spoza Polski mają różne długości, a końcówka
 * i tak dzieli się tak samo. Spacje są nierozdzielające: numer w wąskiej
 * kolumnie ma się uciąć wielokropkiem, a nie złamać na dwie linie.
 */
const groupDigits = (digits: string): string => {
  const groups: string[] = [];
  for (let end = digits.length; end > 0; end -= 3) {
    groups.unshift(digits.slice(Math.max(0, end - 3), end));
  }
  return groups.join(' ');
};

/**
 * Numer telefonu w jednym napisie („+48 695 971 897”).
 *
 * Kontrakt trzyma kierunkowy i numer osobno; sklejanie jest sprawą prezentacji,
 * więc mieszka tutaj, a nie w DTO ani w komponentach.
 */
export const formatPhoneNumber = (phoneNumber: PhoneNumberDto): string => {
  const digits = String(phoneNumber.number ?? '').replace(/\D/g, '');
  if (!digits) return phoneNumber.dialCode ?? '';
  return `${phoneNumber.dialCode} ${groupDigits(digits)}`;
};
